/**
 * ScheduleATourHero — Weidner Via6 page hero for /schedule-a-tour.
 * See `FloorPlansHero.tsx` and `_PageImageHeroBody.tsx` for the shared
 * pattern. Owns its slot registration, contentSchema, and hidden
 * literal-path anchors; visual rendering is delegated to the body.
 */

import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { RichTextContent, EditableSlotGroup } from '@vibesites/runtime/react';
import { PageImageHeroBody } from './_PageImageHeroBody';

const bgDef = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Schedule a tour hero image',
    },
  },
  sourceBinding: {
    collection: 'photo_gallery',
    defaultIndex: 0,
    fieldMappings: { image: 'image', alt: 'alt_text' },
  },
};

export function ScheduleATourHero() {
  return (
    <>
      <PageImageHeroBody
        titlePath="scheduleatourhero.title"
        bgPath="scheduleatourhero.bg_image"
        bgDef={bgDef}
        defaultTitle="Schedule A Tour"
        keywords={['tour', 'lobby', 'leasing', 'entrance']}
        pageHint="scheduleatourhero"
        altText="Schedule a tour hero image"
      />

      <RichTextContent
        path="scheduleatourhero.title"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      />
      <EditableSlotGroup
        groupPath="scheduleatourhero.bg_image"
        definition={bgDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ScheduleATourHero',
  displayName: 'Schedule A Tour Hero',
  tokens: {
    'scheduleatourhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: 'Schedule A Tour',
    },
  },
  slotGroups: {
    'scheduleatourhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: {
          label: 'Image',
          type: 'image',
          defaultField: 'property_featured_image',
        },
        alt: {
          label: 'Alt Text',
          type: 'text',
          defaultValue: 'Schedule a tour hero image',
        },
      },
      sourceBinding: {
        collection: 'photo_gallery',
        defaultIndex: 0,
        fieldMappings: { image: 'image', alt: 'alt_text' },
      },
    },
  },
};

(ScheduleATourHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ScheduleATourHero;
